// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export  = require('./$.export')
  , setProto = require('./$.set-proto');

if(setProto)$export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto){
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch(e){
      return false;
    }
  }
});


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-core/~/core-js/modules/es6.reflect.set-prototype-of.js
 ** module id = 548
 ** module chunks = 0 1 4 5 6 7 8
 **/